import React from "react";
import { Tooltip } from "antd";
import { EditOutlined, DisconnectOutlined, PlusOutlined, MenuOutlined, BookOutlined, CloseOutlined, EyeOutlined } from '@ant-design/icons';

export default props => {
    function returnStyle() {
        return props.label ? { paddingRight: 6, paddingLeft: 4 } : {}
    }

    function returnIcon() {
        switch (props.type) {
            case "edit":
                return <EditOutlined style={returnStyle()} />
            case "delete":
                return <DisconnectOutlined style={returnStyle()} />
            case "disconnect":
                return <DisconnectOutlined style={returnStyle()} />
            case "plus":
                return <PlusOutlined style={returnStyle()} />
            case "menu-unfold":
                return <MenuOutlined style={returnStyle()} />
            case "book":
                return <BookOutlined style={returnStyle()} />
            case "close":
                return <CloseOutlined style={returnStyle()} />
            case "eye":
                return <EyeOutlined style={returnStyle()}/>
        }
    }

    return (
        <Tooltip placement="bottom" title={props.text}>
            <button className={`button-icon ${props.className}`} onClick={() => props.callback()}
                style={props.label ? { paddingRight: 15 } : {}}>
                {returnIcon()}{props.label}
            </button>
        </Tooltip>
    )
}
